import {
  SHORTENER_RESOLUTION_CLEAR,
  SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
  SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_REQUEST,
  SHORTENER_RESOLUTION_SET_TARGET_LINKS,
} from '../../../actions/actionTypes';

const defaultState = null;

const targetLink = (state = defaultState, action) => {
  switch (action.type) {
    case SHORTENER_RESOLUTION_SET_TARGET_LINKS: {
      const { targetLink } = action.payload;
      return targetLink || defaultState;
    }

    case SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE:
    case SHORTENER_RESOLUTION_CLEAR:
    case SHORTENER_RESOLUTION_FETCH_LINK_TO_RESOLVE_REQUEST:
      return defaultState;

    default:
      return state;
  }
};

export default targetLink;
